<template>
  <div>
    <v-layout wrap justify-center>
      <v-flex xs12 sm12 md12 class="align-self-center">
        <v-layout wrap justify-center>
          <v-flex xs12>
            <v-img src="./../../assets/images/sellerreg.png" height="35vh" cover>
              <v-layout style="padding-top:4vh!important" wrap justify-center>
                <v-flex xs12 lg5  text-center>
                  <span
                    style="font-family:opensansbold;font-size:40px;color:#fff;line-height:1"
                  >Grow your business through Web Peedika</span>
                </v-flex>
                <v-flex xs12>
                  <span
                    style="color: #FFFFFF;;font-size:20px;letter-spacing: 0px;font:Open Sans;"
                  >Gain New Customers with Search Engine Visibility</span>
                </v-flex>
                <v-flex pt-5 pb-5 xs12>
                  <span 
                    style="color: #FFFFFF;;font-size:14px;padding-top:5px;padding-bottom:5px;letter-spacing: 0px;border: 0.5px solid #919191;border-radius:20px;font:Open Sans bold;"
                  ><span  style="padding:20px;">
                      Seller Profile Details
                      </span></span>
                </v-flex>
              </v-layout>
            </v-img>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
     <v-layout wrap justify-center>
      <v-flex xs12 sm6 md6 class="align-self-center">
        <sellerRegistrationForm></sellerRegistrationForm>
      </v-flex>
     </v-layout>         
  </div>
</template>
<script>
import sellerRegistrationForm from "./sellerRegistrationForm";
export default {
  components: {
    sellerRegistrationForm,
  },
};
</script>